import { api } from "@/lib/api";

const VKEY = "sate_visitor_id";

export function getVisitorId() {
  let id = localStorage.getItem(VKEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(VKEY, id);
  }
  return id;
}

let lastTracked = 0;

export function trackVisit() {
  if (Date.now() - lastTracked < 2000) return;
  lastTracked = Date.now();
  try {
    api
      .post("/track/visit", {
        visitor_id: getVisitorId(),
        path: window.location.pathname,
        referrer: document.referrer || "",
      })
      .catch(() => {});
  } catch {
    /* tracking must never break the page */
  }
}

export function trackEvent(type) {
  try {
    api
      .post("/track/event", { visitor_id: getVisitorId(), type })
      .catch(() => {});
  } catch {
    /* ignore */
  }
}
